import StorageUtil from '../../core/util/storage_util';
import { Env } from '../../core/env';
import { isSoloare } from '../../core/models/js_env';

/// ローカルストレージ新規登録促進パーツ非表示キー論理名
const HIDE_NEW_REGISTRATION_PROMOTION_PARTS_KEY = 'HIDE_NEW_REGISTRATION_PROMOTION_PARTS';
/// ローカルストレージ新規登録促進パーツ非表示の設定値
const HIDE_NEW_REGISTRATION_PROMOTION_PARTS_VALUE = '1';
/// ローカルストレージ新規登録促進の有効日数
const LOCAL_COMMERCIAL_PACK_DATE_LIMIT = 30;

export class SignUpPromotionAction {
  /// 初期表示
  static init(containerClass: any) {
    // ソロアリの場合は何もしない
    if (isSoloare(Env.SITE_TYPE)) return

    /// NEW_ENTRY_LEAD(Cookie)の値取得
    const isNewEntryLeadElement = document.getElementById('isNewEntryLead') as HTMLInputElement;
    const isNewEntryLead = isNewEntryLeadElement.dataset.isNewEntryLead;

    /// ローカルストレージの値取得
    const hideNewRegistrationPromotionParts = StorageUtil.getItemWithExpiration(HIDE_NEW_REGISTRATION_PROMOTION_PARTS_KEY);

    /// エリア表示制御
    const signUpPromotionAreaList = document.getElementById('signUpPromotionArea') as HTMLInputElement;
    if (signUpPromotionAreaList === null) return;
    if ((isNewEntryLead === "false") && (hideNewRegistrationPromotionParts !== HIDE_NEW_REGISTRATION_PROMOTION_PARTS_VALUE)) {
      /// 新規登録促進パーツ表示
      signUpPromotionAreaList.style.display = 'block';
    } else {
      /// 新規登録促進パーツ非表示
      signUpPromotionAreaList.style.display = 'none';
    }

    return new containerClass();
  }

  /// 閉じるボタン押下時の処理
  static closeButtonClick() {

    const signUpPromotionAreaList = document.getElementById('signUpPromotionArea') as HTMLInputElement;
    if (signUpPromotionAreaList === null) return;

    /// 新規登録促進パーツパーツ非表示
    signUpPromotionAreaList.style.display = 'none';

    /// ローカルストレージに非表示の値を更新する
    StorageUtil.setItemAfterDates(
      HIDE_NEW_REGISTRATION_PROMOTION_PARTS_KEY,
      HIDE_NEW_REGISTRATION_PROMOTION_PARTS_VALUE,
      LOCAL_COMMERCIAL_PACK_DATE_LIMIT
    );
  }
}
